import { Navigate, useParams } from "react-router-dom";

/**
 * ScenarioPersonaRedirect
 *
 * Backwards-compat for the legacy persona-id URL.
 *
 *   /projects/:id/scenarios/:outlineId/as/:personaId
 *     → /projects/:id/scenarios/:outlineId#persona-{personaId}
 *
 * Under the Y model the persona is a lens on one scenario, not a
 * separate URL. The unified detail page reads the hash on mount and
 * expands the matching persona panel. External deep links from old
 * emails / Slack messages still land on the right section.
 */
export function ScenarioPersonaRedirect() {
  const {
    id: projectId,
    outlineId,
    personaId,
  } = useParams<{
    id: string;
    outlineId: string;
    personaId: string;
  }>();

  if (!projectId || !outlineId) {
    return <Navigate to="/projects" replace />;
  }

  const target = personaId
    ? `/projects/${projectId}/scenarios/${outlineId}#persona-${personaId}`
    : `/projects/${projectId}/scenarios/${outlineId}`;

  return <Navigate to={target} replace />;
}
